// Module
var code = "<div class=\"input-group\"> <input class=\"form-control\" readonly=\"readonly\" ng-value=\"getDisplayValue()\"> <div class=\"input-group-addon\" style=\"cursor:pointer\" ng-click=\"openPartModal()\"> <i class=\"fa fa-search\"></i> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'parts/ui-formly/types/selectPart/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;